import React, { useEffect } from "react";
import Select, { components, useStateManager } from "react-select";
import { multiCusutomStyle } from "../../../../pages/Multicustomstyles";
import DatePickerSample from "../../DatePicker";
import {
  CommonOption,
  CustomCOption,
  OptionBB,
} from "../../../../labels/Lableoption";
import { customStyles } from "../../../../pages/customStyles";
import { AxiosInstance } from "../../../../axios";
import { useState } from "react";

const Option = (props) => {
  return (
    <div style={{ textAlign: "left" }}>
      <components.Option {...props}>
        {!props.isDisabled && (
          <input
            type="checkbox"
            disabled={props.isDisabled}
            checked={props.isSelected}
            onChange={() => null}
            style={{
              ...(props.isSelected ? multiCusutomStyle.checkboxChecked : {}),
              width: "18px", // Change the width of the checkbox
              height: "18px", // Change the height of the checkbox
            }}
          />
        )}
        {props.isDisabled ? (
          <label style={multiCusutomStyle.optionLabelss}>{props.label}</label>
        ) : (
          <label style={multiCusutomStyle.optionLabel}>{props.label}</label>
        )}
      </components.Option>
    </div>
  );
};
function SubjectTopics(props) {
  const [testTopic, setTestTopic] = useState([]);
  useEffect(() => {
    setTestTopic([]);
    AxiosInstance.post("/api/all/getTestTopics/bySubject", {
      category: props.cate,
      sub_category: props.subcate,
      course_name: props.course_name,
      subject: props.record.STSubject,
      type: props.type,
    })
      .then((res) => {
        if (res.data.status === true) {
          if (res.data.data.length > 0) {
            const test_topic = res.data.data.map((item, index) => ({
              value: item.id,
              label: item.test_topic,
              type: item.type,
              category: item.category,
              subcategory: item.subcategory,
              course_name: item.course_name,
              subject: item.subject,
              test_topic: item.test_topic,
            }));
            setTestTopic(test_topic);
          } else {
            setTestTopic([]);
          }
        }
      })
      .catch((error) => {
        return error;
      });
  }, [props.record.STSubject]);

  return (
    <div className="row box ">
      <div className="col-md-12">
        <fieldset className="mt-3">
          <legend className="w-auto"> Subjects and Topics {props.record.id > 1 ? "-" : ""}{" "}
            {props.record.id > 1 ? props.record.id : ""}</legend>
          <form className="row g-3">
            <div className="col-md-6">
              <label for="STSubject" class="form-label confirm_value ">
                Subject
              </label>
              <Select
                class="Inputs"
                // id="STSubject"
                value={
                  props.record.STSubject !== null &&
                    props.record.STSubject !== ""
                    ? {
                      value: props.record.STSubject_id,
                      label: props.record.STSubject,
                    }
                    : null
                }
                name="STSubject"
                options={props.subject_test}
                closeMenuOnSelect={true}
                hideSelectedOptions={true}
                isClearable={true}
                onChange={(es) =>
                  props.handleSubjectOptionChange(
                    es,
                    props.record.id,
                    "STSubject"
                  )
                }
                styles={customStyles} // Apply custom styles her
              />

              {props.record.STSubject_error && (
                <small className="error">{props.record.STSubject_error}</small>
              )}

            </div>
            <div className="col-md-6">
              <label for="STtopic" class="form-label confirm_value ">
                Topic
              </label>
              <Select
                class="Inputs"
                // id="STtopic"
                name="STtopic"
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                isClearable={true}
                isMulti
                onChange={(e) =>
                  props.handleSubjectOptionChange(e, props.record.id, "STtopic")
                }
                options={testTopic}
                value={props.record.STtopic.map((value) => ({
                  value: value.value,
                  label: value.label,
                  type: value.type,
                  category: value.category,
                  subcategory: value.subcategory,
                  course_name: value.course_name,
                  subject: value.subject,
                  test_topic: value.test_topic,
                }))}
                components={{
                  Option: CommonOption, // Correct the syntax here
                }}
                styles={multiCusutomStyle} // Apply custom styles her
              />
              {props.record.STtopic_error && (
                <small className="errors">{props.record.STtopic_error}</small>
              )}

            </div>
            <div className="row mt-2">
              <div className="col-md-12 dflexendcolu">
                {props.record.id != 1 && props.record.id === props.length && (
                  <a
                    className="text-decoration-none me-3"
                    onClick={() => props.deleteSubTop(props.record.id)}
                  >
                    <span className="material-icons download_icon align-middle">
                      remove_circle
                    </span>
                    <span className=" m-0 secondaryButton">
                      Delete This Subject
                    </span>
                  </a>
                )}

                {props.record.id === props.length ? (
                  <a className="text-decoration-none" onClick={props.AddSubTop}>
                    <span className="material-icons download_icon align-middle">
                      add_circle
                    </span>

                    <span className=" m-0 secondaryButton">
                      Add More Subjects
                    </span>
                  </a>
                ) : (
                  /* For all other items, show the delete button */
                  <a
                    className="text-decoration-none me-3"
                    onClick={() => props.deleteSubTop(props.record.id)}
                  >
                    <span className="material-icons download_icon align-middle">
                      remove_circle
                    </span>



                    <span className=" m-0 secondaryButton">
                      Delete This Subject
                    </span>
                  </a>
                )}
              </div>
            </div>
          </form>
        </fieldset>



      </div>
    </div>
  );
}
export default SubjectTopics;
